import { useSelector } from 'react-redux'
import type { RootState } from '../store'

export function usePermission(resource: string, action: string): boolean {
  const permissions = useSelector((state: RootState) => state.admin.permissions)

  if (!permissions) return false

  const resourcePerms = permissions[resource]
  if (!resourcePerms) return false

  return resourcePerms.includes(action)
}

export function useAdminRole() {
  return useSelector((state: RootState) => state.admin.role)
}

export function useAdminUser() {
  return useSelector((state: RootState) => ({
    userId: state.admin.userId,
    email: state.admin.email,
    role: state.admin.role,
    isLoading: state.admin.isLoading,
    error: state.admin.error,
  }))
}
